/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// project imports
import { MessageReply } from 'features/components/base/messages';
import MessageUnread from 'features/components/base/messages/MessageUnread';
import MessageRead from 'features/components/base/messages/MessageRead';
import MessageReplied from 'features/components/base/messages/MessageReplied';
import MessageDeleted from 'features/components/base/messages/MessageDelete';

/**
 * routing for message components
 * 
 * @param props
 * 
 * @return routing for message components
 * 
**/

export class MessageRouter extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Switch>
                <Route exact path={`/messages/unread`} component={MessageUnread} />
                <Route exact path={`/messages/read`} component={MessageRead} />
                <Route exact path={`/messages/replied`} component={MessageReplied} />
                <Route exact path={`/messages/deleted`} component={MessageDeleted} />
                <Route exact path={[ `/messages/reply/:messageId`, `/messages/item/reply/:itemId`]} component={MessageReply} />

                {
                    this.props.location.pathname === '/messages' ? 
                    <Redirect to="/messages/unread" /> : 
                    <Redirect to="/home" />
                }
            </Switch>
        );
    }
}
